import React from "react"
import type { InboxTheme } from "@trycourier/react-inbox"
import { Inbox } from "@trycourier/react-inbox"
import { useColors, useIsDarkMode } from "@mallardbay/lib-react-components"

import { useAuth } from "~utils/hooks/use-auth"

export default function CourierInbox() {
    const { isAuthenticated } = useAuth()

    const inboxTheme = useInboxTheme()
    const brandColors = useBrandColors()

    if (!isAuthenticated) {
        return null
    }

    return (
        <Inbox
            theme={inboxTheme}
            brand={brandColors}
            // hides footer saying 'provided by courier'
            renderFooter={() => null}
        />
    )
}

// color mode awareness lives in CourierInboxProvider, which resolves
// colorMode into the css variables the popup styles use
function useInboxTheme(): InboxTheme {
    return {
        // for mobile view
        // 64px is the height of the header
        // zIndex needs to be high to be above some of the buttons on homepage
        container: {
            zIndex: 1000,
            top: "64px",
        },
        // the header title has no color of its own and inherits the page
        // body color, so pin it to courier's mode-aware title variable
        header: {
            color: "var(--ci-title-color)",
        },
    }
}

function useBrandColors() {
    const colors = useColors()
    const isDarkMode = useIsDarkMode()

    return {
        colors: {
            // courier derives hover/unread tints via tinycolor, which can't
            // parse css variables, so use the resolved hex brand color
            primary: colors.brandDefaultHex,
            // subtle overlay needs to flip with the color mode to stay visible
            tertiary: isDarkMode
                ? colors.whiteAlpha[100]
                : colors.blackAlpha[100],
        },
    }
}
